import { ThisConnector } from '../../../../api/connector'

export interface GetTotalPendingStatusTracesArgs {
  organizationUuid: string
}

export interface GetTotalPendingStatusTracesResponse {
  count: number
}

export async function getTotalVulnerabilitiesPendingApprovalQuery(
  this: ThisConnector,
  { organizationUuid }: GetTotalPendingStatusTracesArgs
) {
  const { count } = await this.connector.get<{
    count: number
  }>(`/${organizationUuid}/approval-workflow/traces/pending-status`)

  const response: GetTotalPendingStatusTracesResponse = {
    count
  }

  return response
}
